import { useRef, useEffect } from "react";
import DOMPurify from "dompurify";
import { Bold, Italic, List, ListOrdered } from "lucide-react";

const Btn = ({ onClick, active, children, label }) => (
  <button
    type="button"
    aria-label={label}
    data-testid={`rte-${label}`}
    onMouseDown={(e) => { e.preventDefault(); onClick(); }}
    className="h-8 w-8 flex items-center justify-center rounded hover:bg-zinc-100 text-zinc-600 transition-colors"
  >
    {children}
  </button>
);

export default function RichTextEditor({ value, onChange }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) {
      ref.current.innerHTML = DOMPurify.sanitize(value || "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const exec = (cmd) => {
    document.execCommand(cmd, false, null);
    onChange(ref.current.innerHTML);
    ref.current.focus();
  };

  return (
    <div className="border border-input rounded-md overflow-hidden">
      <div className="flex items-center gap-1 border-b border-border bg-zinc-50 px-2 py-1">
        <Btn onClick={() => exec("bold")} label="bold"><Bold className="h-4 w-4" /></Btn>
        <Btn onClick={() => exec("italic")} label="italic"><Italic className="h-4 w-4" /></Btn>
        <Btn onClick={() => exec("insertUnorderedList")} label="bullet"><List className="h-4 w-4" /></Btn>
        <Btn onClick={() => exec("insertOrderedList")} label="ordered"><ListOrdered className="h-4 w-4" /></Btn>
      </div>
      <div
        ref={ref}
        contentEditable
        data-testid="client-notes-editor"
        onInput={(e) => onChange(e.currentTarget.innerHTML)}
        className="min-h-[120px] px-3 py-2 text-sm font-[Manrope] outline-none prose prose-sm max-w-none [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5"
      />
    </div>
  );
}
